type RemoveTaskError = {
  notFound: boolean;
};

const removeTaskError: RemoveTaskError = {
  notFound: false,
};

export type { RemoveTaskError };

export { removeTaskError };
